import { z } from "zod";

// ADV-998 — Body schema for POST /api/v1/integrations/webhooks/inbound/generic.
//
// The catch-all inbound endpoint for iPaaS users (Zapier, Make, n8n) and
// customer-built integrations. Customers ship their own integrations against
// this single schema instead of waiting for per-iPaaS adapters. The PRD
// (§3.4) specifies the minimum shape; `payload` stays free-form so customers
// can pass whatever the source emits.

export const inboundGenericEntityTypes = [
  "contact",
  "opportunity",
  "job",
  "invoice",
  "payment",
  "generic",
] as const;

export const InboundGenericEntityTypeSchema = z
  .enum(inboundGenericEntityTypes)
  .describe("Entity Type");
export type InboundGenericEntityType = z.infer<
  typeof InboundGenericEntityTypeSchema
>;

export const InboundGenericEventSchema = z.object({
  event_type: z.string().min(1).describe("Event Type"),
  source: z.string().min(1).describe("Source"),
  entity_type: InboundGenericEntityTypeSchema,
  external_id: z.string().min(1).describe("External ID"),
  occurred_at: z.string().datetime().describe("Occurred At"),
  payload: z.record(z.string(), z.unknown()).describe("Payload"),
});
export type InboundGenericEvent = z.infer<typeof InboundGenericEventSchema>;

export const InboundGenericEventResponseSchema = z.object({
  received: z.literal(true).describe("Received"),
  raw_event_id: z.string().uuid().describe("Raw Event ID"),
});
export type InboundGenericEventResponse = z.infer<
  typeof InboundGenericEventResponseSchema
>;
